import store from "@/store";
import { Chinese } from "./zh";
import { English } from "./en";
import { Vietnamese } from "./vi";
import { Japanese } from "./ja";
import { Korean } from "./ko";
import { Thailand } from "./th";
import { Indonesia } from "./id";
import { French } from './fr';
import { ChineseHK } from './zh-HK';
import { ChineseTW } from './zh-TW';
import { HKM } from "./km";

export const translateModel = (languageCode: string)=>{

  switch (languageCode) {
    case 'CN':
      return Chinese;
      break;
    case 'HK-TW':
      const country = store.getState()?.common?.country || '';
      if (languageCode.indexOf(country) == 0) {
        return ChineseHK;
      } else if(languageCode.indexOf(country) == 3) {  
        return ChineseTW
      } else {
        return ChineseHK;
      }
      break;
    case 'EN':
      return English
      break;
    case 'VN':
    return Vietnamese
    break;
    case 'JP':
    return Japanese
    break;
    case 'KR':
      return Korean
      break;
    case 'TH':
    return Thailand
    break;
    case 'ID':
    return Indonesia
    break;
    case 'FR':
      return French;
      break;
    case 'KM':
      return HKM;
      break;
    default:
      return English;
      break;
  }
};
/** 替换字符串多处数据 */
export function templateReplace(str:string, obj:any) {  
  // 使用正则表达式匹配所有花括号内的内容  
  return str.replace(/\{(\w+)\}/g, (match, key) => {  
      // 使用回调函数从对象中获取相应的值  
      return obj.hasOwnProperty(key) ? obj[key] : match; // 如果对象中没有对应的key，则返回原匹配字符串  
  });  
}  
